// The class
class WidgetForm {
    constructor(baseEl) {
        this.baseEl = baseEl || document;

        this.ui = {
            amountBtn: this.baseEl.querySelectorAll('.js-set-amount'),
            amountInput: this.baseEl.querySelector('#amount'),
        }

        this.bindEvents();
    }

    bindEvents() {
        this.ui.amountBtn.forEach(amount => {
            amount.addEventListener('click', e => this.onClickPresetAmount(e));
        });

        this.ui.amountInput?.addEventListener('change', e => this.toggleAmountBtnClasses(e.currentTarget.value));
    }

    onClickPresetAmount(e) {
        const amount = e.currentTarget.dataset.amount;
        this.ui.amountInput.value = amount.replaceAll(/\.0+$/g, "");
        this.toggleAmountBtnClasses(amount);
    }

    toggleAmountBtnClasses(amount) {
        this.ui.amountBtn.forEach(btn => {
            if(parseFloat(btn.dataset.amount) == parseFloat(amount)) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });
    }
}

// This allows widget.js to initialise the JS and pass in the shadow DOM element
window.gaylWidgetInitialise = function init(shadowDom) {
    console.log("WidgetForm.init", shadowDom);
 
    // Cleans up global scope, but should also allow for multiple widgets on same page to reuse
    delete window.gaylWidgetInitialise;

    new WidgetForm(shadowDom);
}

// This will only get used if accessing the widget URL directly (or if in an iframe?)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new WidgetForm();
    });
} else if(document.currentScript) {
    new WidgetForm();
}